import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query, QueryGetAggregateScoreForAuthorArgs } from "../types/generated/graphql";

export const useGetAuthor = (client: ApolloClient<NormalizedCacheObject>, uid: string, authorId: string) => {
  type T = Pick<Query, 'getAggregateScoreForAuthor'>;
  type I = QueryGetAggregateScoreForAuthorArgs;
  const ret = useQuery<T, I>(QUERY_GET_AUTHOR, {
    client, variables: { authorId, profileId: uid },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

const QUERY_GET_AUTHOR = gql`
  query getAggregateScoreForAuthor($authorId: String!, $profileId: String) {
    getAggregateScoreForAuthor(authorId: $authorId, profileId: $profileId) {
      authorId
      score
      rating
      confidence
      explanation
      restricted
      restrictedVideoCount
      videoCount
      videosWithFeedback
      allScoresFromFeedback
      totalOverriddenAgents
      watched {
        id
        title
        description
        thumbnails {
          url
          width
          height
        }
        author {
          id
          name
          url
          thumbnails {
            url
            width
            height
          }
          is_moderator
          is_verified
          is_verified_artist
        }
        published
        view_count
        duration
        is_watched
        is_live
        snapshot_date
        watch_date
      }
      recommended {
        id
        title
        description
        thumbnails {
          url
          width
          height
        }
        author {
          id
          name
          url
          thumbnails {
            url
            width
            height
          }
          is_moderator
          is_verified
          is_verified_artist
        }
        published
        view_count
        duration
        is_watched
        is_live
        snapshot_date
        watch_date
      }
      videos {
        id
        score
        rating
        confidence
        video {
          id
          title
          description
          thumbnails {
            url
            width
            height
          }
          author {
            id
            name
            url
            thumbnails {
              url
              width
              height
            }
            is_moderator
            is_verified
            is_verified_artist
          }
          published
          view_count
          duration
          is_watched
          is_live
          snapshot_date
          watch_date
        }
      }
    }
  }
`;
